import React, { useEffect, useState } from "react";
import { useGlobal } from "../../context/GlobalStore";

export const NetworkBanner = () => {
  const { dispatch } = useGlobal();
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const updateStatus = () => {
      const isOffline = !navigator.onLine;
      setOffline(isOffline);
      dispatch({ type: "SET_OFFLINE", payload: isOffline });
    };

    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);
    updateStatus();

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, [dispatch]);

  if (!offline) return null;

  return (
    <div 
      className="network-banner" 
      style={{
        backgroundColor: "#d32f2f",
        color: "#ffffff",
        padding: "10px",
        textAlign: "center",
        position: "sticky",
        top: 0,
        zIndex: 9999,
        fontWeight: "bold",
        fontSize: "14px"
      }}
    >
      You are offline – the app will retry when connection returns.
    </div>
  );
};
